import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RelatedPartyTypeEqualsTo, RulesetResult } from '../rules';
import RelatedPartyRelationshipEqualsTo from '../rules/RelatedPartyRelationshipEqualsTo';
import {
  RELATED_PARTY_RELATIONSHIP,
  RELATED_PARTY_TYPES,
} from '../../../../../../../constants';

class PrincipalIdRuleset implements Ruleset {
  private principalId: any;
  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (
      RelatedPartyTypeEqualsTo.setType(RELATED_PARTY_TYPES.INDIVIDUAL)
        .setPrincipalId(this.principalId)
        .evaluate(data) &&
      !RelatedPartyRelationshipEqualsTo.setRelationship(
        RELATED_PARTY_RELATIONSHIP.LANDLORD
      )
        .setPrincipalId(this.principalId)
        .evaluate(data)
    )
      return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}
export default new PrincipalIdRuleset();
